// KPI Card Component - Handles dynamic data with error boundaries

import React from 'react';
import { ArrowUpRight, ArrowDownRight, Activity } from 'lucide-react';
import URLCell from './URLCell';
import { isValidUrl, extractUrl } from '../../utils/urlUtils';

const KPICard = ({ card }) => {
  // Validate card data
  if (!card || typeof card !== 'object') {
    return (
      <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
        <p className="text-sm text-gray-500">Invalid card data</p>
      </div>
    );
  }

  // Safe defaults
  const Icon = card.icon || Activity;
  const title = card.title || 'Metric';
  const rawValue = card.value !== undefined && card.value !== null ? card.value : 'N/A';
  const value = typeof rawValue === 'string' ? rawValue : String(rawValue);
  const change = card.change || '0%';
  const trend = card.trend || 'up';
  const description = card.description || '';
  const color = card.color || '#3B82F6';
  const lightBg = card.lightBg || 'bg-blue-50';

  // Check if value is a URL
  const isUrl = isValidUrl(value) || (typeof value === 'string' && extractUrl(value));
  const urlValue = isValidUrl(value) ? value : (typeof value === 'string' ? extractUrl(value) : null);

  // Determine if value is long text that should be truncated
  const isLongText = typeof value === 'string' && value.length > 50;
  const displayValue = isLongText ? value.substring(0, 50) + '...' : value;

  return (
    <div className={`${lightBg} rounded-lg p-4 border border-gray-200 card-hover animate-scale-in`}>
      <div className="flex items-start gap-3">
        <div className="p-2.5 rounded-lg flex-shrink-0 hover:scale-110 transition-transform duration-200" style={{ backgroundColor: color }}>
          <Icon className="w-5 h-5 text-white animate-float" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs text-gray-500 mb-1 font-medium uppercase tracking-wide truncate" title={title}>
            {title}
          </p>
          {isUrl && urlValue ? (
            <div className="mt-1">
              <URLCell url={urlValue} displayText={value !== urlValue ? value : null} />
            </div>
          ) : (
            <p 
              className={`text-lg font-semibold text-gray-900 break-words ${isLongText ? 'line-clamp-2' : ''}`} 
              title={value}
            >
              {displayValue}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default KPICard;
